import { render, staticRenderFns } from "./two-column-list.vue?vue&type=template&id=7b0f8f75&"
import script from "./two-column-list.vue?vue&type=script&lang=js&"
export * from "./two-column-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports